export const SELECT = "select";
export const INPUT = "input";
export const DATE_PICKER = "datePicker";
export const NUMBER = "number";
export const SELECT_WITH_NEW_ITEM = "select-with-new-item";
export const PASSWORD = "password";
export const AUTOCOMPLETE = "autocomplete";
export const AUTOCOMPLETE_AREA = "autocomplete-textarea";
export const EXPOSED_FIELD = "exposed";
export const AREA = "area";
